import { FC } from 'react';
import { BoxProps, defaultColors, Flex, IconSize, Spinner } from '@lifechurch/react-ion';

const LoadingScreen: FC<BoxProps> = props => {
  return (
    <Flex alignItems='center' justifyContent='center' marginBlockStart={64} {...props}>
      <Spinner color={defaultColors.gray50} size={IconSize.XL} />
    </Flex>
  );
};

export { LoadingScreen };
